/**
 * Linked case domain entity.
 * Represents a case linked to another case.
 * NOTE: ID fields use string type to support encrypted UUIDs
 */
export class LinkedCaseEntity {
  public id!: string;
  public caseId!: string;
  public linkedCaseId!: string;
  public linkedCaseNumber!: string;
  public linkedCaseTypeName!: string;
  public linkedCaseTypeCategoryName!: string;
  public linkedCaseStatusName!: string;
  public linkedCaseStatusColor!: string;
  public linkedCaseRequestorName!: string;
  public linkedCaseCreatedOn!: string;
  public linkType!: string;
  public linkedOn!: string;
  public linkedByUserId!: string;
  public linkedByUserName!: string;
  public isAutoLinked!: boolean;
}
